export default "__VITE_ASSET__De3kFE_u__"